import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const TextParagraphIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				d="M1 2.5C1 2.22386 1.22386 2 1.5 2H5.5C5.77614 2 6 2.22386 6 2.5V3C6 3.27614 5.77614 3.5 5.5 3.5H4.25V6.75C4.25 7.02614 4.02614 7.25 3.75 7.25H3.25C2.97386 7.25 2.75 7.02614 2.75 6.75L2.75 3.5H1.5C1.22386 3.5 1 3.27614 1 3V2.5Z"
			></path>
			<path
				fill="currentColor"
				d="M8 2.5C8 2.22386 8.22386 2 8.5 2H14.5C14.7761 2 15 2.22386 15 2.5V3C15 3.27614 14.7761 3.5 14.5 3.5H8.5C8.22386 3.5 8 3.27614 8 3V2.5Z"
			></path>
			<path
				fill="currentColor"
				d="M8 6C8 5.72386 8.22386 5.5 8.5 5.5H14.5C14.7761 5.5 15 5.72386 15 6V6.5C15 6.77614 14.7761 7 14.5 7H8.5C8.22386 7 8 6.77614 8 6.5V6Z"
			></path>
			<path
				fill="currentColor"
				d="M1.5 9C1.22386 9 1 9.22386 1 9.5V10C1 10.2761 1.22386 10.5 1.5 10.5H14.5C14.7761 10.5 15 10.2761 15 10V9.5C15 9.22386 14.7761 9 14.5 9H1.5Z"
			></path>
			<path
				fill="currentColor"
				d="M1 13C1 12.7239 1.22386 12.5 1.5 12.5H14.5C14.7761 12.5 15 12.7239 15 13V13.5C15 13.7761 14.7761 14 14.5 14H1.5C1.22386 14 1 13.7761 1 13.5V13Z"
			></path>
		</svg>
	),
)
